import React from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import Button from '@mui/material/Button';

import { useState, useEffect,useContext } from "react";
import Context from "context/context";

import { toast } from "react-toastify";

import vraRadPoolAPI from 'apis/panel/vraRadPool/vraRadPool';
import "./vraRadPool.css"

import Autocomplete from "@mui/material/Autocomplete";



const EditVraRadPool = ({ data, onClose, warningModal, setWarningModal, handleGetVraNeededWarningCountAPI }) => {
    const { state, dispatch } = useContext(Context);
    const [allVraRosters,setAllVraRosters] = useState([])
    const [vraRadMappingId,setVraRadMappingId]= useState('')
    const [radSrfName,setRadSrfName]= useState('')
   
    const [vra1RosterId,setVra1RosterId]= useState('')
    const [vra2RosterId,setVra2RosterId]= useState('')
    const [vra3RosterId,setVra3RosterId]= useState('')
    const [vra4RosterId,setVra4RosterId]= useState('')
    
    const [open, setOpen] = useState(false);
   
     // api's

     const {getAllVraRosterAPI,updateVraRadPoolAPI } = vraRadPoolAPI()


    const handleGetEditDataObj = async () => {

        try {
            dispatch({ type: "SET_LOADING", payload: true });
           
            if (data) {
                
                setVraRadMappingId(data?.vraRadMappingId)
                setRadSrfName(data?.radSrfName)
                setVra1RosterId(data?.vra1RosterId)
                
                setVra2RosterId(data?.vra2RosterId)
               
                setVra3RosterId(data?.vra3RosterId)
               
                setVra4RosterId(data?.vra4RosterId)
                
            }
            dispatch({ type: "SET_LOADING", payload: false });
        } catch (error) {
            console.log({ error });
            dispatch({ type: "SET_LOADING", payload: false });

        }
        
    }
 
    const handleGetAllVraRoster = async ()=>{
        dispatch({ type: "SET_LOADING", payload: true });
        try {
            const res = await getAllVraRosterAPI();
            
            if(res?.status == "Ok"){
                setAllVraRosters(res?.data?.vraRosterIds)
            }
            dispatch({ type: "SET_LOADING", payload: false });
        } catch (error) {
            console.log(error);
            dispatch({ type: "SET_LOADING", payload: false });
        }
    }
  
    
    useEffect(() => {
        handleGetEditDataObj()
        handleGetAllVraRoster()
    }, [])

   
    const handleSaveEdit = async (e) => {
       e.preventDefault();
   
       const emptyVra = (countValue) => {
        let values = [];
       
        if (countValue > 2 && !vra3RosterId) values.push("Third");
        if (countValue > 1 && !vra2RosterId) values.push("Secondary");
        if (countValue > 0 && !vra1RosterId) values.push("Primary");

        return values;
      };
      
    
      let count = 0;
      if (vra4RosterId) {
        count = 4;
      } else if (vra3RosterId) {
        count = 3;
      } else if (vra2RosterId) {
        count = 2;
      }
      
     
      if (count > 0) {
        const result = emptyVra(count);
        let message,toastId;
      
        if (result.length === 3) { 
          message = `Please update the ${result[2]}, ${result[1]} and ${result[0]} VRA before submitting.`;
           toastId = `update 1,2,3 vra`;
        } else if (result.length === 2) {
          message = `Please update the ${result[1]} and ${result[0]} VRA before submitting.`;
          toastId = `update 1,2 vra`;
        } else if (result.length === 1) {
          message = `Please update the ${result[0]} VRA before submitting.`;
          toastId = `update 1 vra`;
        }
      
        if(result.length > 0){
          // Show the toast message
          return toast.error(message,{toastId:toastId});
        }
      }
      

      
         let values = {
            vraRadMappingId,
            vra1RosterId,
            vra2RosterId,
            vra3RosterId,
            vra4RosterId
         };
        
        
        
        
         dispatch({ type: "SET_LOADING", payload: true });
  
         const res = await updateVraRadPoolAPI(values);
   
         if (res.status === "Ok") {
           onClose();
           handleGetVraNeededWarningCountAPI()
           dispatch({ type: "SET_LOADING", payload: false });
           return toast.success("Data Saved Successfully", {
             toastId: "Data Saved Successfully",
           });
         } else {
           dispatch({ type: "SET_LOADING", payload: false });
           return toast.error("Error updating data",{toastId:"error"});
         }
       }
     

  
    return (
       
        <Grid container>
  <Grid container spacing={3} >
    
    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb:2 }}>
      <Box className="label"><span style={{fontWeight: 'bold'}}>RAD Name : {radSrfName}</span></Box>
     
    </Grid>
   
    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}></Grid>
    
    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
      <Box className="label">Primary VRA</Box>
       <Autocomplete
                  id="rad-handled-by"
                  options={allVraRosters.filter((v) => v.vraRosterId !== vra2RosterId && v.vraRosterId !== vra3RosterId && v.vraRosterId !== vra4RosterId)} // Remove selected VRA from options
                  getOptionLabel={(option) => option.srfName || ""}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  isOptionEqualToValue={(option, value) =>
                    option.vraRosterId === value.vraRosterId
                  }
                  value={
                    allVraRosters?.filter((v) => v.vraRosterId === vra1RosterId)[0] || {}
                  }
                  onChange={(event, newValue) => {
                    setVra1RosterId(newValue ? newValue.vraRosterId : "");
                  }}
                />
     </Grid>

    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
      <Box className="label">Secondary VRA</Box>
      <Autocomplete
                  id="rad-handled-by"
                  options={allVraRosters.filter((v) => v.vraRosterId !== vra1RosterId && v.vraRosterId !== vra3RosterId && v.vraRosterId !== vra4RosterId)} // Remove selected VRA from options
                  getOptionLabel={(option) => option.srfName || ""}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  isOptionEqualToValue={(option, value) =>
                    option.vraRosterId === value.vraRosterId
                  }
                  value={
                    allVraRosters?.filter((v) => v.vraRosterId === vra2RosterId)[0] || {}
                  }
                  onChange={(event, newValue) => {
                    setVra2RosterId(newValue ? newValue.vraRosterId : "");
                  }}
                />
   </Grid>

    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
      <Box className="label">Third VRA</Box>
      <Autocomplete
                  id="rad-handled-by"
                  options={allVraRosters.filter((v) => v.vraRosterId !== vra1RosterId && v.vraRosterId !== vra2RosterId && v.vraRosterId !== vra4RosterId)} // Remove selected VRA from options
                  getOptionLabel={(option) => option.srfName || ""}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  isOptionEqualToValue={(option, value) =>
                    option.vraRosterId === value.vraRosterId
                  }
                  value={
                    allVraRosters?.filter((v) => v.vraRosterId === vra3RosterId)[0] || {}
                  }
                  onChange={(event, newValue) => {
                    setVra3RosterId(newValue ? newValue.vraRosterId : "");
                  }}
                />
   
    </Grid>

    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
      <Box className="label">Fourth VRA</Box>
      <Autocomplete
                  id="rad-handled-by"
                  options={allVraRosters.filter((v) => v.vraRosterId !== vra1RosterId && v.vraRosterId !== vra2RosterId && v.vraRosterId !== vra3RosterId)} // Remove selected VRA from options
                  getOptionLabel={(option) => option.srfName || ""}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  isOptionEqualToValue={(option, value) =>
                    option.vraRosterId === value.vraRosterId
                  }
                  value={
                    allVraRosters?.filter((v) => v.vraRosterId === vra4RosterId)[0] || {}
                  }
                  onChange={(event, newValue) => {
                    setVra4RosterId(newValue ? newValue.vraRosterId : "");
                  }}
                />
   
    </Grid>
  </Grid>

  <Grid container sx={{ pl: 4, pr: 5, mt: 4, justifyContent: "center" }}>
    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
      <Button className="cancelButton" onClick={onClose}>Cancel</Button>
    </Grid>

    <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
      <Button className="saveButton" onClick={handleSaveEdit}>Save</Button>
    </Grid>
  </Grid>
  </Grid>

    )
}


export default EditVraRadPool;
